import styled from "@emotion/styled";
import {
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import AppBarCustom from "../../component/AppBar";
import TextFieldCustom from "../../component/textFieldCustom";
import React, { useState } from "react";
import SelectCustom from "../../component/selectCustom";
import { MapsForm } from "../../component/MapsForm";

import Api from "../../api/RestApi.json";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AddAPhotoRounded,
  ClearRounded,
  DeleteRounded,
  ImageRounded,
  SendRounded,
} from "@mui/icons-material";

import { Editor } from "react-draft-wysiwyg";
import { ContentState, convertToRaw, EditorState } from "draft-js";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
export default function DaerahForm(params) {
  const theme = useTheme();
  const goTo = useNavigate();
  const { state } = useLocation();
  // const { data } = state;
  const { data, lastProfil, lastGambar } = state;
  const [profilStatus, setProfilStatus] = React.useState(
    lastProfil?.nama || null
  );
  const [gambarStatus, setGambarStatus] = React.useState(
    lastGambar?.nama || null
  );
  const [id, setId] = useState(data.id || "");
  const [judul, setJudul] = useState(data.judul || "");
  const [kategori, setKategori] = useState(data.kategori || "");
  const [penulis, setPenulis] = useState(data.penulis || "");
  const [profil, setProfil] = useState(data.profil || null);
  const [deskripsi, setDeskripsi] = useState(data.deskripsi || "");
  const [gambar, setGambar] = useState(data.gambar || "");

  const handleProfilDelete = () => {
    setProfil(null);
    setProfilStatus(null);
  };
  const handleGambarDelete = () => {
    setGambar(null);
    setGambarStatus(null);
  };

  const handleImagesProfil = (e) => {
    setProfil(e.target.files[0]);
  };

  const handleImagesGambar = (e) => {
    setGambar(e.target.files[0]);
  };

  const contentBlock = htmlToDraft(deskripsi);
  var editor;
  if (contentBlock) {
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    );
    editor = EditorState.createWithContent(contentState);
  }
  const [editorState, setEditorState] = useState(
    editor || EditorState.createEmpty()
  );

  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    setDeskripsi(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  };

  const [save, setSave] = React.useState(false);
  const [errorSave, setErrorSave] = React.useState(false);

  const [profilProgress, setProfilProgress] = React.useState(0);
  const [profilComplete, setProfilComplete] = React.useState(false);
  const [profilError, setProfilError] = React.useState(null);

  const [gambarProgress, setGambarProgress] = React.useState(0);
  const [gambarComplete, setGambarComplete] = React.useState(false);
  const [gambarError, setGambarError] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const [deleteStatus, setDeleteStatus] = React.useState(null);

  const storePost = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    setProfilProgress(0);
    setProfilComplete(false);
    setProfilError(null);

    setGambarProgress(0);
    setGambarComplete(false);
    setGambarError(null);

    setDeleteStatus(null);
    const data = {
      id,
      kategori,
      judul,
      penulis,
      deskripsi,
    };

    try {
      var response = "";
      if (data.id !== "") {
        response = await axios.put(Api.artikel + "/" + data.id, data);
      }
      // setValidation(data.nama + ' Berhasil Ditambahkan!');
      // console.log(response);
      // goTo(0);
    } catch (error) {
      // console.log(error.response.data);
    }

    const now = Date.now();
    if (profil) {
      const formData = new FormData();
      const nameFile = now + "_Profil_" + profil.name;
      formData.append("id_foreign", id);
      formData.append("kategori", "Profil");
      formData.append("file", profil, nameFile);
      formData.append("tipe", profil.type);
      formData.append("ukuran", profil.size);

      try {
        var response = "";
        response = await axios.post(Api.file, formData, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProfilProgress(percentCompleted);
          },
        });
        setProfilComplete(true);
        // goTo("/potensi");
      } catch (error) {
        console.error("Error uploading file:", error);
        setProfilError("File gagal di Upload. Tolong ulangi kembali.");
      }

      if (lastProfil) {
        if (profil.name !== lastProfil.nama) {
          try {
            var deleteFile = "";
            deleteFile = await axios.delete(Api.file + "/" + lastProfil.id);
          } catch (error) {}
        }
      }
    } else if (profil == null && profilStatus == null) {
      try {
        var deleteFile = "";
        deleteFile = await axios.delete(Api.file + "/" + lastProfil.id);
      } catch (error) {}
    }

    if (gambar) {
      const formData = new FormData();
      const nameFile = now + "_Gambar_" + gambar.name;
      formData.append("id_foreign", id);
      formData.append("kategori", "Gambar");
      formData.append("file", gambar, nameFile);
      formData.append("tipe", gambar.type);
      formData.append("ukuran", gambar.size);

      try {
        var response = "";
        response = await axios.post(Api.file, formData, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setGambarProgress(percentCompleted);
          },
        });
        setGambarComplete(true);
        // goTo("/potensi");
      } catch (error) {
        console.error("Error uploading file:", error);
        setGambarError("File gagal di Upload. Tolong ulangi kembali.");
      }

      if (lastGambar) {
        if (gambar.name !== lastGambar.nama) {
          try {
            var deleteFile = "";
            deleteFile = await axios.delete(Api.file + "/" + lastGambar.id);
          } catch (error) {}
        }
      }
    } else if (gambar == null && gambarStatus == null) {
      try {
        var deleteFile = "";
        deleteFile = await axios.delete(Api.file + "/" + lastGambar.id);
      } catch (error) {}
    }
    setIsLoading(false);
    goTo("/daerah");
    goTo(0);
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: 0,
        bgcolor: "#E1E1E1",
      }}
    >
      <AppBarCustom selected="Kecamatan" />
      {/* <Toolbar sx={{ padding: 10 }} /> */}

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader theme={theme} />

        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", marginBottom: 2 }}
            align="left"
          >
            Form Artikel Daerah {data.nama ? " : " + data.nama : ""}
          </Typography>
          <Button
            variant="contained"
            color="error"
            onClick={(e) => goTo("/daerah")}
          >
            Kembali
          </Button>
        </Stack>

        <Box padding={2} bgcolor={"white"} borderRadius={4}>
          <form onSubmit={storePost}>
            <Grid
              container
              spacing={4}
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid size={{ xs: 12, md: 12 }}>
                <TextFieldCustom
                  title="Judul"
                  name="judul"
                  id="judul"
                  value={judul}
                  onChange={(e) => setJudul(e.target.value)}
                  type="text"
                  label="..."
                  required={true}
                  disabled={true}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <TextFieldCustom
                  title="Kategori"
                  name="kategori"
                  id="kategori"
                  value={kategori}
                  onChange={(e) => setKategori(e.target.value)}
                  type="text"
                  label="kategori"
                  required={true}
                  disabled={true}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <TextFieldCustom
                  title="Nama Penulis"
                  name="penulis"
                  id="penulis"
                  value={penulis}
                  onChange={(e) => setPenulis(e.target.value)}
                  type="text"
                  label="Penulis"
                  required={true}
                />
              </Grid>
              {id !== "" && (
                <Grid size={{ xs: 12, md: 12 }}>
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"flex-end"}
                    spacing={2}
                  >
                    <Typography
                      align="left"
                      variant="subtitle1"
                      fontWeight={"bold"}
                    >
                      Profil
                    </Typography>
                    <Stack
                      width={"90%"}
                      direction={{ xs: "column", md: "row" }}
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                      spacing={2}
                    >
                      <Button
                        variant="contained"
                        component="label"
                        color="primary"
                        startIcon={<AddAPhotoRounded />}
                        sx={{ textTransform: "capitalize" }}
                      >
                        Pilih Gambar
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={handleImagesProfil}
                        />
                      </Button>
                      {profil && (
                        <Typography>{"Baru : " + profil.name}</Typography>
                      )}
                      {profilStatus && (
                        <Typography>{"Lama : " + profilStatus}</Typography>
                      )}
                      {profilStatus && (
                        <IconButton
                          aria-label="delete"
                          color="error"
                          onClick={handleProfilDelete}
                        >
                          <DeleteRounded />
                        </IconButton>
                      )}
                    </Stack>
                  </Stack>
                </Grid>
              )}

              <Grid size={{ xs: 12, md: 12 }}>
                <Stack
                  width={"100%"}
                  direction={"row"}
                  alignItems={"start"}
                  justifyContent={"flex-end"}
                  spacing={2}
                >
                  <Typography
                    align="left"
                    variant="subtitle1"
                    fontWeight={"bold"}
                  >
                    Deskripsi
                  </Typography>

                  <Box boxShadow={4} padding={2} width={"90%"}>
                    <Editor
                      editorState={editorState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorClassName"
                      editorStyle={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        minHeight: "200px",
                        padding: "10px",
                        lineHeight: "1",
                      }}
                      toolbar={{
                        fontFamily: {
                          options: [
                            "Arial",
                            "Georgia",
                            "Impact",
                            "Tahoma",
                            "Times New Roman",
                            "Verdana",
                            "Roboto",
                            "Open Sans",
                          ],
                          className: undefined,
                          component: undefined,
                          dropdownClassName: undefined,
                        },
                        options: [
                          "fontFamily",
                          "fontSize",
                          "blockType",
                          "inline",
                          "list",
                          "textAlign",
                          "link",
                          "history",
                        ],
                        inline: {},
                        list: { inDropdown: true },
                        textAlign: {},
                        link: { inDropdown: true },
                        history: {},
                        // Other toolbar options...
                      }}
                      onEditorStateChange={onEditorStateChange}
                    />
                  </Box>
                </Stack>
              </Grid>
              {id !== "" && (
                <Grid size={{ xs: 12, md: 12 }}>
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"flex-end"}
                    spacing={2}
                  >
                    <Typography
                      align="left"
                      variant="subtitle1"
                      fontWeight={"bold"}
                    >
                      Gambar
                    </Typography>
                    <Stack
                      width={"90%"}
                      direction={{ xs: "column", md: "row" }}
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                      spacing={2}
                    >
                      <Button
                        variant="contained"
                        component="label"
                        color="primary"
                        startIcon={<AddAPhotoRounded />}
                        sx={{ textTransform: "capitalize" }}
                      >
                        Pilih Gambar Deskripsi
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={handleImagesGambar}
                        />
                      </Button>
                      {gambar && (
                        <Typography>{"Baru : " + gambar.name}</Typography>
                      )}
                      {gambarStatus && (
                        <Typography>{"Lama : " + gambarStatus}</Typography>
                      )}
                      {gambarStatus && (
                        <IconButton
                          aria-label="delete"
                          color="error"
                          onClick={handleGambarDelete}
                        >
                          <DeleteRounded />
                        </IconButton>
                      )}
                    </Stack>
                  </Stack>
                </Grid>
              )}
              <Grid size={{ xs: 12, md: 12 }}>
                {profilProgress > 0 && (
                  <Typography variant="body2" color="textSecondary">
                    Upload Profil: {profilProgress}%
                  </Typography>
                )}
                {gambarProgress > 0 && (
                  <Typography variant="body2" color="textSecondary">
                    Upload Gambar: {gambarProgress}%
                  </Typography>
                )}
              </Grid>
              {id == "" && (
                <Grid size={{ xs: 12, md: 12 }}>
                  <Box justifySelf={"left"}>
                    <Typography variant="caption" textAlign={"left"}>
                      *Tambah Foto Profil dan Gambar Deskripsi hanya tersedia
                      saat sunting data.
                    </Typography>
                  </Box>
                </Grid>
              )}
              <Grid size={{ xs: 12, md: 12 }}>
                <Box justifySelf={"center"}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    size="large"
                    startIcon={<SendRounded />}
                  >
                    Kirim
                  </Button>
                </Box>
              </Grid>
              {isLoading && (
                <Grid size={{ xs: 12, md: 12 }}>
                  <Box width={"100%"}>
                    <LinearProgress />
                  </Box>
                </Grid>
              )}

              {/* <Grid size={{ xs: 12, md: 12 }}>
                <Typography variant="h4">Hasil</Typography>
                <div
                  dangerouslySetInnerHTML={{
                    __html: draftToHtml(
                      convertToRaw(editorState.getCurrentContent())
                    ),
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 12 }}>
                <Typography variant="h4">Deskripsi</Typography>
                <div>{deskripsi}</div>
              </Grid> */}
            </Grid>
          </form>
        </Box>
      </Box>
    </Box>
  );
}
const optionsKategori = [
  { value: "Pertanian", label: "Pertanian" },
  { value: "Perkebunan", label: "Perkebunan" },
  { value: "Peternakan", label: "Peternakan" },
  { value: "Kehutanan", label: "Kehutanan" },
  { value: "Kelautan & Perikanan", label: "Kelautan & Perikanan" },
  { value: "Pertambangan & Energi", label: "Pertambangan & Energi" },
  { value: "Pariwisata", label: "Pariwisata" },
  { value: "Industri", label: "Industri" },
  { value: "Infrastruktur", label: "Infrastruktur" },
  { value: "Jasa & Perdagangan", label: "Jasa & Perdagangan" },
  { value: "Hotel", label: "Hotel" },
  { value: "Pelabuhan", label: "Pelabuhan" },
  { value: "Bandara", label: "Bandara" },
  { value: "Terminal", label: "Terminal" },
  { value: "Rumah Sakit", label: "Rumah Sakit" },
  { value: "Kawasan Industri", label: "Kawasan Industri" },
  { value: "Kawasan Ekonomi Khusus", label: "Kawasan Ekonomi Khusus" },
];

const optionsKecamatan = [
  { value: "Basarang", label: "Basarang" },
  { value: "Bataguh", label: "Bataguh" },
  { value: "Dahadup", label: "Dahadup" },
  { value: "Kapuas Barat", label: "Kapuas Barat" },
  { value: "Kapuas Hilir", label: "Kapuas Hilir" },
  { value: "Kapuas Hulu", label: "Kapuas Hulu" },
  { value: "Kapuas Kuala", label: "Kapuas Kuala" },
  { value: "Kapuas Murung", label: "Kapuas Murung" },
  { value: "Kapuas Tengah", label: "Kapuas Tengah" },
  { value: "Kapuas Timur", label: "Kapuas Timur" },
  { value: "Mandau Talawang", label: "Mandau Talawang" },
  { value: "Mantangai", label: "Mantangai" },
  { value: "Pasak Talawang", label: "Pasak Talawang" },
  { value: "Pulau Petak", label: "Pulau Petak" },
  { value: "Selat", label: "Selat" },
  { value: "Tamban Catur", label: "Tamban Catur" },
  { value: "Timpah", label: "Timpah" },
];
